import { IconButton, InputAdornment, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import Iconify from '../../../../../reusable-components/iconify';
import { formStyle } from '../../contractStyles';

FormMoneyField.propTypes = {
    fieldName: PropTypes.string,
    disabled: PropTypes.bool,
    focusedField: PropTypes.string,
    setFocusedField: PropTypes.func,
};

export default function FormMoneyField({ fieldName, disabled = false, focusedField, setFocusedField }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={fieldName}
            control={control}
            rules={{
                pattern: {
                    value: /^\d+(\.\d{1,2})?$/,
                    message: 'Enter a valid amount (e.g., 100.00)',
                },
            }}
            render={({ field, fieldState }) => (
                <NumericFormat
                    inputRef={field.ref}
                    key={field.id}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                        }
                    }}
                    customInput={TextField}
                    onFocus={() => setFocusedField(fieldName)}
                    fullWidth
                    disabled={disabled}
                    size="small"
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    value={!field.value === '' || Number.isNaN(field.value) ? '' : field.value}
                    onValueChange={(values) => field.onChange(values.floatValue ?? '')}
                    allowNegative={false}
                    thousandSeparator
                    decimalScale={2}
                    fixedDecimalScale
                    sx={{
                        ...formStyle,
                        '& .MuiInputAdornment-root': {
                            marginRight: 0,
                        },
                    }}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        endAdornment:
                            field.value && focusedField === fieldName ? (
                                <InputAdornment position="end">
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            field.onChange('');
                                        }}
                                        edge="end"
                                        tabIndex={-1}
                                    >
                                        <Iconify icon="eva:close-outline" />
                                    </IconButton>
                                </InputAdornment>
                            ) : null,
                        sx: {
                            '& .MuiInputAdornment-root': {
                                color: '#000000',
                            },
                        },
                    }}
                />
            )}
        />
    );
}
